<template>
  <div id="app">
    <nav-wrap @func="goVideo" v-if="$route.meta.keepAlive"></nav-wrap>
    <transition name="underslide">
      <!-- 关于我们的bar -->
      <div
        class="about-info"
        v-if="aboutShow"
        @mouseover="navBarShow()"
        @mouseleave="navBarHide()"
      >
        <div class="about-cont">
          <!-- bar子导航 -->
          <div class="aboutSpan">
            <bar-span
              :barList="aboutList"
              :title="aboutTitle"
              @goPage="goPage"
            ></bar-span>
          </div>
          <img class="aboutBar" src="@/assets/noticeBar.jpg" alt />
        </div>
      </div>
    </transition>
    <transition name="underslide">
      <!-- 最新动态的bar -->
      <div
        class="about-info"
        v-if="noticeShow"
        @mouseover="navBarShow()"
        @mouseleave="navBarHide()"
      >
        <div class="about-cont">
          <!-- bar子导航 -->
          <div class="aboutSpan">
            <bar-span
              :barList="noticeList"
              :title="noticeTitle"
              @goPage="goPage"
            ></bar-span>
          </div>
          <img class="aboutBar" src="@/assets/aboutBar.jpg" alt />
        </div>
      </div>
    </transition>
    <div>
      <router-view class="wrap" @func="goVideo"></router-view>
      <footer-wrap v-if="$route.meta.keepAlive"></footer-wrap>
      <video-play
        class="video-win"
        v-if="videoShow"
        :videoSrc="videoSrc"
        @closevideo="closevideo"
      ></video-play>
      <!--右侧导航条-->
      <img
       v-if="!$route.meta.sideTipAlive"
        class="littleJ"
        id="googleJ"
        src="/static/img/littkeJ.png"
        alt="吉客云-小吉"
      />
      <ul class="sideTip" v-if="!$route.meta.sideTipAlive">

        <li>
          <a
            style="border-radius: 8px 0px 0px 0px"
            rel="noopener noreferrer external nofollow"
            href="javascript:"
            @click="open53()"
          >
            <div id="online" alt="吉客云-在线咨询"></div>
            <span>在线咨询</span>
          </a>
        </li>
        <li
          class="wei"
          @mouseover="showImg = true"
          @mouseleave="showImg = false"
        >
          <a>
            <div id="weixin" alt="吉客云-微信咨询"></div>
            <span>微信咨询</span>
          </a>
          <div class="weixinCode" v-if="showImg">
            <img alt="微信咨询" src="/static/img/imgs/customer.jpg" />
          </div>
        </li>
        <!-- <li>
          <a
            target="_blank"
            rel="noopener noreferrer external nofollow"
            @click="
              go(
                'https://amos.alicdn.com/getcid.aw?spm=a1z10.1-c.0.0.179c89f3pegOOo&v=3&groupid=0&s=1&charset=utf-8&uid=differsoft88&site=cntaobao&fromid=cntaobao'
             )
            "
          >
            <div id="wang" alt="吉客云-旺旺"></div>
            <span>旺旺咨询</span>
          </a>
        </li> -->
        <li class="pos" @mouseover="show = true" @mouseleave="show = false">
          <a>
            <div id="telphone" alt="吉客云-电话"></div>
            <span>电话咨询</span>
          </a>
          <transition name="leftslide">
            <div class="tel" v-if="show">电话咨询：0571-88223317</div>
          </transition>
        </li>
        <li @click="back" id="backTop">
          <a
            title="回到顶部"
            style="
              border-radius: 0px 0px 0px 8px;
              border-bottom: 0px solid #f0f0f0;
              height: 33px;
            "
          >
            <div id="backup" alt="吉客云-回到顶部"></div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import navWrap from "@/components/nav-wrap";
import footerWrap from "@/components/footer-wrap";
import videoPlay from "@/components/video-play";
import barSpan from "@/components/bar-span.vue";
import { postApi ,getServiceWXCode} from "@/api/index";
export default {
  name: "app",
  components: {
    navWrap,
    footerWrap,
    videoPlay,
    barSpan,
  },
  data() {
    return {
      videoShow: false,
      showNav: true,
      show: false,
      showImg: false,
      wechatImg: "",
      path: "",
      aboutTitle: "关于我们",
      aboutList: [
        { type: 0, label: "公司简介", flag: 3 },
        { type: 1, label: "发展历程", flag: 3 },
        { type: 2, label: "企业文化", flag: 3 },
        { type: 3, label: "荣誉资质", flag: 3 },
        { type: 4, label: "联系我们", flag: 3 },
      ],
      noticeTitle: "最新动态",
      noticeList: [
        { type: 0, label: "公司公告", id: 1, flag: 2 },
        { type: 1, label: "平台对接", id: 2, flag: 2 },
        { type: 2, label: "需求反馈", id: 3, flag: 2 },
        { type: 3, label: "版本升级", id: 4, flag: 2 },
        { type: 4, label: "新闻中心", id: 5, flag: 2 },
        { type: 5, label: "现场实拍", id: 6, flag: 2 },
      ],
    };
  },

  // 判断路由
  mounted() {
    this.path = this.$route.path;
  },
  // 在组件的computed中使用全局state
  computed: {
    aboutShow() {
      return this.$store.state.aboutShow;
    },
    noticeShow() {
      return this.$store.state.noticeShow;
    },
  },
  watch: {
    $route(to, from) {},
  },
  methods: {
    open53() {
    var _53 = $53.createApi();
    _53.push('cmd', 'kfclient');
    _53.push('type', 'new');      /*popup是浮动窗口，new是新窗口*/
    _53.query();
  },
    goVideo(src) {
      this.videoShow = true;
      this.videoSrc = src;
    },
    //关闭视频弹窗
    closevideo() {
      this.videoShow = false;
    },
    go(url,name) {
      if (name) {
    window.open(url,name);
      } else {
    window.open(url);
      }
    },
    //回到顶部
    back() {
      window.scrollTo(0, 0);
    },
    scrollToTop() {
      let topBtn = document.getElementById("backTop");
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let browserHeight = window.outerHeight;
      if (scrollTop > browserHeight) {
        topBtn.style.display = "block";
      } else {
        topBtn.style.display = "none";
      }
    },
    //导航bar消失
    navBarHide() {
      this.$store.commit("navSlideHide");
    },
    //导航bar出现
    navBarShow(type) {
      this.$store.commit("navSlideShow", type);
    },
    //控制二级页跳转
    goPage(item) {
      if (item.flag == 3) {
        this.$store.commit("changeAbout", item.type);
        var goAbout = {
          0: () => {
            this.$router.push({
              name: "brief",
            });
          },
          1: () => {
            this.$router.push({
              name: "Development",
            });
          },
          2: () => {
            this.$router.push({
              name: "culture",
            });
          },
          3: () => {
            this.$router.push({
              name: "honour",
            });
          },
          4: () => {
            this.$router.push({
              name: "contact",
            });
          },
        };
        if (item.type) {
          goAbout[item.type].call(this);
        } else {
          this.$router.push({
            name: "brief",
          });
        }
      }
      if (item.flag == 2) {
        this.current = 3;
        this.$store.commit("changeNotice", item.id);
        this.$router.push("/notice");
      }
    },
    getRequest() {
      var url = encodeURI(location.search || window.location.hash);
      var redurectHead = document.location.protocol;
      var regular = /(edi)(_[0|1])(_\d+)(_\d{10})/;
      var redirectUrl = regular.test(url)
        ? "https://api.jackyun.com/callback/edi/authorization"
        : "https://esapi.wdgj.com/OpenAPIX/OnAuthorizationSuccess";
      if (url) {
        let params = {
          url: redirectUrl,
          data: url,
        };
        postApi(params)
          .then(function (res) {})
          .catch(function (error) {});
        // this.axios
        //   .post(redirectUrl, { data: url, c: Math.round(Math.random() * 10000) })
      }
    },
    // 获取url参数
    getUrlParam(name, containChinese) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return containChinese ? decodeURI(r[2]) : unescape(r[2]);
      return null;
    },
    getServiceWXCode() {
      getServiceWXCode().then((res) => {
        var data = res.result.data;
        if (data) {
          this.wechatImg = res.result.data;
        }
      });
    },
  },
  created() {
    this.getRequest();
    this.getServiceWXCode();
    var dynamicIds = this.getUrlParam("dynamicId"),
      pageIds = this.getUrlParam("pageId");

    if (!pageIds) {
      if(window.location.host.indexOf('localhost') <= -1) { // 本地开发环境循环跳转优化
        window.location.href = "/";
      }
    } else {
      const actions = new Map([
        [
          "platform",
          () => {
            this.$router.replace("/platform");
          },
        ],
        [
          "notice",
          () => {
            this.$router.replace("/notice");
            this.$store.commit("changeNotice", 1);
          },
        ],
        [
          "statistics",
          () => {
            this.$router.replace("/statistics");
          },
        ],
        [
          "videos",
          () => {
            this.$router.replace("/videos");
          },
        ],
        [
          "custom",
          () => {
            this.$router.replace("/custom");
          },
        ],
        [
          "calculator",
          () => {
            this.$router.replace("/calculator");
          },
        ],
        // ["brief",()=>{this.$router.replace("/brief");}],
        // ["development",()=>{this.$router.replace("/development");}],
        // ["culture",()=>{this.$router.replace("/culture");}],
        // ["honour",()=>{this.$router.replace("/honour");}],
        // ["contact",()=>{this.$router.replace("/contact");}],
        [
          "yunClass",
          () => {
            this.$router.replace("/yunClass");
          },
        ],
        [
          "recruitment",
          () => {
            this.$router.replace("/recruitment");
          },
        ],
        [
          "notice1",
          () => {
            if (!dynamicIds) {
              this.$router.replace("/notice");
            } else {
              this.$router.push({
                name: "notice",
                params: { id: 1, dynamicId: dynamicIds },
              });
            }
            this.$store.commit("changeNotice", 1);
          },
        ],
        [
          "notice2",
          () => {
            this.$router.replace("/notice");
            this.$store.commit("changeNotice", 2);
          },
        ],
        [
          "notice3",
          () => {
            this.$router.replace("/notice");
            this.$store.commit("changeNotice", 3);
          },
        ],
        [
          "notice4",
          () => {
            this.$router.replace("/notice");
            this.$store.commit("changeNotice", 4);
          },
        ],
        [
          "notice5",
          () => {
            if (!dynamicIds) {
              this.$router.replace("/notice");
            } else {
              this.$router.push({
                name: "notice",
                params: { id: 5, dynamicId: dynamicIds },
              });
            }
            this.$store.commit("changeNotice", 5);
          },
        ],
        [
          "notice6",
          () => {
            this.$router.replace("/notice");
            this.$store.commit("changeNotice", 6);
          },
        ],
      ]);
      let action = actions.get(pageIds);
      action.call(this);
    }
  },
};
</script>

<style>
/* * {
  padding: 0;
  margin: 0;
  border: 0;
} */
ul {
  padding: 0;
  margin: 0;
}
.wrap {
  min-width: 100%;
  position: relative;
  top: 0;
}
.el-timeline-item__timestamp {
  font-size: 16px !important;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  text-align: center;
  color: #333;
  width: 100%;
  overflow: hidden;
  margin: 0 auto;
}
/**顶部导航栏样式 */
.nav-top {
  width: 100%;
  height: 112px;
  background-color: #001241;
}
/* QQ悬浮样式 */
.littleJ {
  width: 72px;
  height: 95px;
  position: fixed;
  right: 0px;
  top: 205px;
  z-index: 9999;
}
.sideTip {
  z-index: 9999;
  position: fixed;
  right: 0px;
  top: 300px;
  box-shadow: 0px 0px 6px rgba(72, 72, 72, 0.16);
  border-radius: 8px 0px 0px 8px;
  background: #fff;
}

.sideTip > li > a {
  width: 72px;
  height: 70px;
  text-align: center;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  display: flex;
  flex-direction: column;
}

.sideTip > li > a > div {
  width: 25px;
  height: 25px;
  opacity: 1;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  margin: 10px auto 6px;
  background-size: 100% 100%;
}
.sideTip > li > a > span {
  font-size: 14px;
  color: #186cea;
}
.sideTip > li:hover a {
  background: #186cea;
}
.sideTip > li:hover span {
  color: #fff;
}
#online {
  background-image: url("/static/img/imgs/7422@2x.png");
}

#qq {
  background-image: url("/static/img/imgs/7314@2x.png");
}
#weixin {
  background-image: url("/static/img/imgs/wechat.png");
}
#wang {
  background-image: url("/static/img/imgs/7315@2x.png");
}

#telphone {
  background-image: url("/static/img/imgs/7316@2x.png");
}

#backup {
  width: 16px;
  height: 8px;
  background-image: url("/static/img/imgs/7321@2x.png");
}
#write {
  background-image: url("/static/img/imgs/7394@2x.png");
}
.sideTip>li:hover #online {
  background-image: url("/static/img/imgs/7418@2x.png");
}
.sideTip>li:hover #qq {
  background-image: url("/static/img/imgs/7323@2x.png");
}
.sideTip > li:hover #weixin {
  background-image: url("/static/img/imgs/wechat-hover.png");
}
.sideTip > li:hover #wang {
  background-image: url("/static/img/imgs/7324@2x.png");
}

.sideTip > li:hover #telphone {
  background-image: url("/static/img/imgs/7325@2x.png");
}
.sideTip > li:hover #write {
  background-image: url("/static/img/imgs/7400@2x.png");
}
.sideTip > li:hover #backup {
  background-image: url("/static/img/imgs/7326@2x.png");
}

.pos,
.wei {
  position: relative;
}
.weixinCode {
  background-color: #fff;
  position: absolute;
  top: -30px;
  right: 72px;
  width: 119px;
  height: 119px;
  animation: show-nav 0.7s forwards;
  -webkit-animation: show-nav 0.7s forwards;
  -moz-animation: show-nav 0.7s forwards;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
  border-radius: 3px;
  transition: all 1s linear;
  -webkit-transition: all 1s linear;
  -o-transition: all 1s linear;
}

.weixinCode img {
  width: 100%;
  height: 100%;
}
.tel {
  position: absolute;
  text-align: center;
  top: 0px;
  right: 72px;
  width: 250px;
  height: 70px;
  line-height: 70px;
  background: #186cea;
  color: #fff;
  font-size: 14px;
}

/**右侧qq,tel动画 */

@keyframes bounceInLeft {
  0% {
    transform: translate3d(500px, 0, 0);
  }

  60% {
    /*  opacity: 1;*/
    transform: translate3d(0px, 0, 0);
  }

  75% {
    transform: translate3d(0px, 0, 0);
  }

  90% {
    transform: translate3d(0px, 0, 0);
  }

  100% {
    transform: translate3d(0px, 0, 0);
  }
}
/**右侧qq,tel动画 */
.leftslide-enter-active {
  transition: all 0.5s ease;
}
.leftslide-leave-active {
  transition: all 0.5s ease;
}
.leftslide-enter,
.leftslide-leave-to {
  transform: translateX(250px);
  opacity: 0;
}

/**underslide动画 */

.underslide-leave-active,
.underslide-enter-active {
  transition: all 0.5s ease;
}
.underslide-leave-active,
.underslide-enter {
  height: 0px !important;
}
.underslide-leave,
.underslide-enter-active {
  height: 342px;
}

.about-info {
  position: absolute;
  width: 100%;
  top: 100px;
  height: 270px;
  background: rgba(248, 248, 248, 1);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  z-index: 1;
  overflow: hidden;
}
.about-cont {
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.aboutSpan {
  width: 560px;
  float: left;
  margin-top: 50px;
}
.aboutBar {
  width: 502px;
  float: right;
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue